namespace $.$$ {
	
	$mol_style_define($bog_card_tag, {
        padding: {
            top: '0.5rem',
            bottom: '0.5rem',
            left: '1rem',
            right: '1rem',
        },
        backgroundColor: 'rgba(99, 102, 241, 0.1)',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'rgba(99, 102, 241, 0.2)',
        borderRadius: '100px',
        font: {
            size: '0.85rem',
        },
        color: '#94a3b8',
        transition: 'all 0.3s',
        cursor: 'default',
        ':hover': {
            backgroundColor: 'rgba(99, 102, 241, 0.2)',
            borderColor: '#6366f1',
            color: '#f8fafc',
            transform: 'translateY(-2px)',
        },
    })
	
}
